import {
  removeUrlParams,
  updateUrlWithParam,
} from '@doda/common/src/utils/urlUtil';
import { convertQueryToStaticUrl } from '@doda/common/src/logics/staticUrl';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { REMOVE_PARAM_LIST } from '../constants';

type GenerateCreatePageHref = (arg: {
  currentUrl: string;
  hasSearchParams: boolean;
  featuredId: string;
}) => (pageNum: number) => string;

/**
 * ページャーの href 生成関数を返す関数
 *
 * @param {Object} param - 引数のオブジェクト
 * @param {string} param.currentUrl - 現在のURL
 * @param {boolean} param.hasSearchParams - 検索パラメータがあるかどうかのフラグ
 * @param {string} param.featuredId - 特集枠ID
 * @returns {Function} ページ数を引数にとり、生成されたURLを返す関数
 */
export const generateCreatePageHref: GenerateCreatePageHref =
  ({ currentUrl, hasSearchParams, featuredId }) =>
  (pageNum: number) => {
    if (hasSearchParams) {
      const baseUrl = removeUrlParams(currentUrl, REMOVE_PARAM_LIST);

      return pageNum > 1
        ? updateUrlWithParam(baseUrl, 'page', `${pageNum}`)
        : removeUrlParams(baseUrl, ['page']);
    }

    const pageQuery = pageNum > 1 ? { page: pageNum } : {};
    return convertQueryToStaticUrl(
      { fid: featuredId, ...pageQuery },
      DODA_SITE_URL.featuredJobList
    );
  };
